import { useContext, useEffect, useState } from "react";

import { UserContext } from "@context/user";
import useAxios from "@hooks/use-axios";

const SUMMARY_URL = "dashboard/v1/summary";

const useOpsDashboard = () => {
    const { opsPaymentModel } = useContext(UserContext);
    const { axiosInstance, loading } = useAxios({ base: "ops", initialLoader: true });
    // The refresh POST gets its own instance so busting the Redis cache never flips the
    // page-level loader (which would blank the tiles) and its success message lands as a
    // toast instead of a blocking Swal modal.
    const { axiosInstance: refreshAxiosInstance, loading: refreshing } = useAxios({
        base              : "ops",
        alertTypeOnSuccess: "toast"
    });
    const [summary, setSummary] = useState(null);

    const readSummary = (res) => {
        const result = res.data || res;
        return result.data || result;
    };

    useEffect(() => {
        const fetchSummary = async () => {
            const res = await axiosInstance.get(SUMMARY_URL);
            setSummary(readSummary(res));
        };
        fetchSummary();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const refresh = async () => {
        const res = await refreshAxiosInstance.post(`${SUMMARY_URL}/refresh`);
        setSummary(readSummary(res));
    };

    return {
        stats           : summary?.stats || {},
        pendingActions  : summary?.pending_actions || [],
        activeDebitNotes: summary?.active_debit_notes || [],
        // The response echoes the model it answered for; the toggle is only the
        // fallback for the first render, before the summary lands.
        paymentModel    : summary?.payment_model || opsPaymentModel,
        generatedAt     : summary?.generated_at,
        loading,
        refreshing,
        refresh
    };
};

export default useOpsDashboard;
